var WfEasyXdm = function () { };

WfEasyXdm.prototype.init = function () {

    // Initialize channel varible - used for wfaMSG.socket in fetchAttr and sendMessage
    // methods below
    this.channel = '';

    // ************************************************************************************
    // Get and set the values for frameId and siteName. This code can be difficult to debug
    // in the integrated environment. You can move this to the document ready section of
    // of the DefaultLayout.cshtml file and set the values to MOD.easyXdmFrameId and 
    // MOD.easyXdmSiteName global variables - then set the local prototype opjects to the 
    // global values.

    // Initialize private varibles for frameId and xdmDomain
    var _frameId = '';
    var _siteName = '';

    // 1st preference: is for the MOD.easyXdmFrameId value. This value is set in the 
    // DefaultLayout.cshtml file and comes from the YYY encrypted string that is 
    // posted to the entitlements/update endpoint.
    if (MOD !== undefined) {
        if (MOD.easyXdmFrameId !== undefined &&
            MOD.easyXdmFrameId !== '') {
            _frameId = MOD.easyXdmFrameId;
        }

        if (MOD.easyXdmSiteName !== undefined &&
            MOD.easyXdmSiteName !== '') {
            _siteName = MOD.easyXdmSiteName;
        }
    }

    // 2nd preference: is to get the value from the iFrame src attribute or the current
    // window.location.
    var _frameIdQueryValue = this.getQueryParamValue('trgIfrm');
    if ((_frameId === '') &&
        (_frameIdQueryValue !== undefined && _frameIdQueryValue !== null && _frameIdQueryValue !== '')) {
        _frameId = _frameIdQueryValue;        
    }

    var _siteNameQueryValue = this.getQueryParamValue('xdmDomain');
    if ((_siteName === '') &&
        (_siteNameQueryValue !== undefined && _siteNameQueryValue !== null && _siteNameQueryValue !== '')) {
        _siteName = _siteNameQueryValue;
    }

    // 3rd preference: (public only) involves browser storage
    if (window.location.pathname.toLowerCase().indexOf('public') !== -1) {
        // If we got a value in the 1st or 2nd preference steps above save the value to the 
        // browser storage. We may need this after a redirect. At this point the src 
        // attribute will still be present, but will no longer be the window.location, 
        // and will no longer be available as modern browsers block communication between
        // an iFrame and it's parents when the domains are different (this is cross site
        // scripting).
        if (_frameId !== '') {
            localStorage.setItem('frameId', _frameId);
        }

        if (_siteName !== '') {
            localStorage.setItem('siteName', _siteName);
        }

        // If we did not get a value in the 1st or 2nd preference steps above and there
        // is a value in the browser storage use that. 
        if (_frameId === '') {
            _frameId = localStorage.getItem('frameId');
        }

        if (_siteName === '') {
            _siteName = localStorage.getItem('siteName');
        }
    }

    // Place the private value in the frameInfo object
    this.frameInfo = { 'FRAMEID': _frameId };

    // Place the private value in the siteName object
    this.siteName = _siteName;
    // ************************************************************************************

    this.domain = this.siteName + '/resources/js/research/hash.html';

    this.startCommunication();

    return false;
};

WfEasyXdm.prototype.getQueryParamValue = function (queryParamName) {
    var results = new RegExp('[\?&]' + queryParamName + '=([^&#]*)').exec(window.location.href);

    if (results == null) {
        return null;
    } else {
        return decodeURI(results[1]) || 0;
    }
}

WfEasyXdm.prototype.startCommunication = function () {
    return this.fetchAttr();
};

WfEasyXdm.prototype.fetchAttr = function () {
    return this.channel = new wfaMSG.Socket({
        remote: this.siteName
    });
};

WfEasyXdm.prototype.get = function (name) {
    var regExp = new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)');
    var matches = regExp.exec(location.search);
    return matches
        ? decodeURIComponent(matches[1])
        : null;
};

//
// takes a js object to send to wf over easyxdm
//
WfEasyXdm.prototype.sendMessage = function (msg) {
    var xdmMessage = $.extend({}, this.frameInfo, msg);
    console.log('Sending: ', xdmMessage);
    return MOD.WfEasyXdm.channel.postMessage(
        JSON.stringify(xdmMessage)
    );
};

//
// sends the document size, for resizing iframe on WF side
//
WfEasyXdm.prototype.sendWindowSize = function (additionalHeight, additionalWidth) {
    var doc = document.body;

    var msgObj = {
        'FRAMESIZE': {
            height: doc.clientHeight + (additionalHeight || 0),
            width: doc.clientWidth + (additionalWidth || 0)
        }
    };

    return this.sendMessage(msgObj);
};

//
// sends the document size, for resizing iframe on WF side
//
WfEasyXdm.prototype.sendKeepAlive = function () {
    var msgObj = { 'ALIVE': '' };
    return this.sendMessage(msgObj);
};

//
// opens a PDF. settings = documentKey and url
//
WfEasyXdm.prototype.openPdf = function (settings) {

    var url = settings['url'];

    if (_.isUndefined(url) || !_.isUndefined(settings['documentKey'])) {
        url =
            (window.location.protocol + '//' + window.location.hostname) +
            ('~/Report/' + settings['documentKey']).resolveUrl();
    }

    var msgObj = {
        'PDF': encodeURI(url)
    };
    return this.sendMessage(msgObj);
};

//
// redirects site based on a link
//
WfEasyXdm.prototype.redirectLink = function (settings) {

    var urlkey = settings['urlkey'];
    var uri = settings['uri'];

    var msgObj = { EXTSITE: { urlkey: urlkey, uri: uri } };

    if (urlkey && uri) {
        return this.sendMessage(msgObj);
    }
};

//
// send a disclosure event link
//
WfEasyXdm.prototype.sendDisclosure = function (settings) {

    var disclosureType = settings['DISC'];

    var msgObj = { DISC: disclosureType };

    if (disclosureType) {
        return this.sendMessage(msgObj);
    }
};